import { Descriptions } from "antd";
import { useTranslation } from "react-i18next";
import type { LeadFormFieldView } from "../types";

interface Props {
	schema: { fields: LeadFormFieldView[] };
	answers: Record<string, unknown>;
}

/** `section` javob bermaydi (spec §4.1, 17-tur). */
const NON_ANSWERABLE = new Set(["section"]);

/** Bool yorliqlari (`t("answers.yes")` / `t("answers.no")`) chaqiruvchidan keladi. */
interface BoolLabels {
	yes: string;
	no: string;
}

/** Qiymatni o'qiladigan matnga aylantiradi. */
export function formatAnswer(value: unknown, boolLabels: BoolLabels): string {
	if (value === null || value === undefined || value === "") {
		return "—";
	}

	if (typeof value === "boolean") {
		return value ? boolLabels.yes : boolLabels.no;
	}

	if (Array.isArray(value)) {
		return value.map((item) => formatAnswer(item, boolLabels)).join("; ");
	}

	if (typeof value === "object") {
		return JSON.stringify(value);
	}

	return String(value);
}

/**
 * Javoblarni PINLANGAN forma versiyasi bo'yicha ko'rsatadi.
 *
 * ⚠️ Faqat `answers` da MAVJUD kalitlar chiqadi. Server ko'rinmaydigan
 * maydonlarni allaqachon tashlagan (spec §4.3 invariant 2); ularni
 * «bo'sh» deb ko'rsatish operatorni «xodim to'ldirmagan» degan noto'g'ri
 * xulosaga olib kelardi.
 *
 * ⚠️ Sxemada yo'q, lekin `answers` da bor kalitlar OXIRIDA xom nomi
 * bilan ko'rsatiladi — jimgina yashirish ma'lumot yo'qotish bo'lardi.
 */
export function LeadAnswers({ schema, answers }: Props) {
	const { t } = useTranslation("leads");
	const boolLabels: BoolLabels = { yes: t("answers.yes"), no: t("answers.no") };
	const known = new Set(schema.fields.map((field) => field.key));

	const rows = schema.fields
		.filter((field) => !NON_ANSWERABLE.has(field.type) && field.key in answers)
		.map((field) => ({ key: field.key, label: field.label, value: answers[field.key] }));

	const extra = Object.keys(answers)
		.filter((key) => !known.has(key))
		.map((key) => ({ key, label: key, value: answers[key] }));

	return (
		<Descriptions bordered column={1} size="small">
			{[...rows, ...extra].map((row) => (
				<Descriptions.Item key={row.key} label={row.label}>
					{formatAnswer(row.value, boolLabels)}
				</Descriptions.Item>
			))}
		</Descriptions>
	);
}
